export enum ELocalStorageKeys {
 ChatId = 'chat_id',
 TemporaryToken = 'temporary_token',
 Token = 'token',
 Timezone = 'timezone',
 BusinessTerms = 'businessTerms',
 Illustrations = 'illustrations',
 Company = 'company',
}
